var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.346,
    height: 11.991,
    viewBox: "0 0 16.346 11.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16074",
    "data-name": "Group 16074",
    transform: "translate(-313.454 -363.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16073",
    "data-name": "Group 16073",
    transform: "translate(685.293 406.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22273",
    "data-name": "Path 22273",
    d: "M-368-34.374c-.27-.182-.511-.34-.746-.5a14.873,14.873,0,0,1-2.923-2.681.537.537,0,0,1-.035-.752,13.661,13.661,0,0,1,5.017-3.894,7.309,7.309,0,0,1,3.038-.651,7.582,7.582,0,0,1,3.137.718.222.222,0,0,0,.305-.049c.519-.53,1.045-1.053,1.572-1.574a.537.537,0,0,1,.762-.056.541.541,0,0,1,0,.829c-.512.519-1.029,1.033-1.545,1.549q-4.62,4.619-9.244,9.235a.911.911,0,0,1-.395.231.508.508,0,0,1-.558-.294.529.529,0,0,1,.109-.625c.343-.351.691-.7,1.039-1.041C-368.315-34.077-368.163-34.217-368-34.374Zm5.784-5.842a2.661,2.661,0,0,0-3.5.468,2.608,2.608,0,0,0-.208,3.236Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22274",
    "data-name": "Path 22274",
    d: "M-293.264,3.838c.289-.278.548-.523.8-.773.327-.322.647-.651.977-.969a.3.3,0,0,1,.208-.079,2.7,2.7,0,0,0,2.932-2.245,6.873,6.873,0,0,0,.024-.73.267.267,0,0,1,.054-.165q1.236-1.243,2.479-2.479a.424.424,0,0,1,.064-.035c.352.288.737.563,1.074.888.56.539,1.095,1.106,1.63,1.671A.529.529,0,0,1-283-.314,13.771,13.771,0,0,1-287.88,3.51a7.246,7.246,0,0,1-5.036.44c-.066-.018-.132-.04-.2-.061Z",
    transform: "translate(-72.648 -37.271)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeClose);
export default __webpack_public_path__ + "static/media/icon-eye-close.bcc7d5feb89c17fc9e37030b0a502f16.svg";
export { ForwardRef as ReactComponent };